import { useState, useEffect, useRef } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { Formik } from "formik";
import { Slide, ToastContainer, toast } from "react-toastify";
import { useTranslation } from "react-i18next";
import { DefaultLayout } from "../../../../layouts/Default";
import { TopNavigation } from "../../../../themes/Default/components/TopNavigation";
import { Button } from "../../../../themes/Default/components/TopNavigation/components/Button";
import { ButtonBack } from "../../../../themes/Default/components/TopNavigation/components/Button";
import { Tabs } from "../../../../themes/Default/components/Tabs";
import { Main } from "../../../../themes/Default/components/Main";
import { Breadcrumps } from "../../../../themes/Default/components/Breadcrumps";
import { Link } from "../../../../themes/Default/components/Breadcrumps/components/Link";
import { Form } from "../../../../themes/Default/components/Form";
import { Row } from "../../../../themes/Default/components/Form/components/Row";
import { Field } from "../../../../themes/Default/components/Form/components/Row/components/Field";
import { Title } from "../../../../themes/Default/components/Title";
import { Wizard } from "../../../../themes/Default/components/Wizard";
import { Step } from "../../../../themes/Default/components/Wizard/Step";
import { Select } from "../../../../themes/Default/components/Form/components/Select";
import { groupProgressTestsManagement } from "../../../../hooks/api/GroupProgressTestsManagement/GroupProgressTestsManagement";
import { prepareSelect } from "../../../../services/core/Select";
import { groupsManagement } from "../../../../hooks/api/GroupsManagement";
import { useUserToken } from "../../../../hooks/core/UserToken";
import { roles } from "../../../../services/utils/Roles";
import { useViewGroupMutation } from "../../../../hooks/api/GroupsManagement/GroupsManagement";

const AddProgressTest = () => {
    const navigate = useNavigate();
    const { t } = useTranslation("common");
    const { groupId } = useParams();
    const formRef = useRef(null);
    const [formErrors, setFormErrors] = useState([]);
    const { useGroupProgressTestsListMutation } = groupProgressTestsManagement;
    const [groupProgressTestsList] = useGroupProgressTestsListMutation();
    const [progressTests, setProgressTests] = useState();
    const [hasProgress, setHasProgress] = useState(false);
    const [hasReport, setHasReport] = useState(false);
    const [hasPlan, setHasPlan] = useState(false);
    const [viewGroup] = useViewGroupMutation();

    const { useAddProgressTestsMutation } = groupsManagement;
    const [addTest] = useAddProgressTestsMutation();

    const tabs = [
        { title: t('groups.attendance'),onClick: () => gotoAttendanceTab(groupId)  },
        ...(hasPlan ? [
            { title: t('groups.planning'), onClick: () => gotoPlanningTab(groupId)},
        ] : []),
        ...(hasProgress ? [
            { title: t('groups.progress'), onClick: () => gotoProgressTab(groupId)},
        ] : []),
        { title: t('groups.progressTest'),isActive: true },
        ...(hasReport ? [
            { title: t('reports.title'),onClick: () => gotoReportTab(groupId)},
        ] : []), 
        { title: t('documents'), onClick: () => gotoDocumentsTab(groupId)},
        { title: t('notes'), onClick: () => gotoNotesTab(groupId)},
    ];

    const [{ getDecoded }] = useUserToken();
    const decodedToken = getDecoded();
    if (
        decodedToken?.roles.includes(roles.SUPER_ADMIN) ||
        decodedToken?.roles.includes(roles.SECRETARY) ||
        decodedToken?.roles.includes(roles.DIRECTOR) || 
        decodedToken?.roles.includes(roles.DIRECTOR_OF_STUDIES)
    ) {
        tabs.push({
            title: t("settings.title"),
            onClick: () => gotoEditTab(groupId),
        });
    }

    const gotoPlanningTab = (groupId) => {
        navigate("/groups/" + groupId + "/planning");
    }

    const gotoProgressTab = (groupId) => {
        navigate("/groups/" + groupId + "/progress");
    }

    const gotoReportTab = (groupId) => {
        navigate("/groups/" + groupId + "/reports");
    }

    const gotoNotesTab = (groupId) => {
        navigate("/groups/" + groupId + "/notes");
    }

    const gotoDocumentsTab = (groupId) => {
        navigate("/groups/" + groupId + "/documents");
    }

    const gotoAttendanceTab = (groupId) => {
        navigate("/groups/" + groupId + "/attendance");
    }

    const gotoEditTab = (groupId) => {
        navigate("/groups/edit/" + groupId);
    }
    
    const onSave = () => {
        if (formRef.current) {
            formRef.current.handleSubmit();
        }
    };

    const onSaved = (values) => {
        addTest({body: values, groupId}).then((result) => {
            if (result?.error) {
                setFormErrors(result?.error?.data?.error?.violations);
                toast.error(result.error.data.error.responseMessage);
            } else {
                navigate("/groups/" + groupId + "/progress/test/" + result?.data?.id);
            }
        });
        
    };

    useEffect(() => {
        viewGroup(groupId).then((result) => {
            setHasReport(result?.data?.hasReport);
            setHasProgress(result?.data?.hasProgress);
            setHasPlan(result?.data?.hasPlan);
        });
        groupProgressTestsList().then((result) => {
            let options = [];
            result?.data?.records.map((test) => {
                options.push({
                    id: test.id,
                    name: test.name,
                });
            });
            setProgressTests(prepareSelect(options));
        });     
    }, []);


    return (
        <DefaultLayout>
            
            <TopNavigation>
                <ButtonBack to={"/groups/" + groupId + "/tests"} />
                <Button title={t('save')} icon="fa-regular fa-floppy-disk" onClick={onSave}></Button>
            </TopNavigation>
            <Tabs tabs={tabs} />
            <Main>
                <Title>{t('Testovi')}</Title>
                <Breadcrumps>
                    <Link title={t("groups.title")} icon="fa-user-group" />
                    <Link title={t("Testovi")} isActive={true} />
                </Breadcrumps>
                <br/>
                <br/>
                <br/>
                <Wizard>
                    <Step title={t('Tip testa')} isActive={true} />
                    <Step title={t('Rezultati')} isChecked={true}  />
                </Wizard>
                <br/>
                <br/>
                <br/>
                <Formik
                    innerRef={formRef}
                    initialValues={{ 
                        test: "",
                    }}
                    onSubmit={onSaved}
                >
                    {({ values, handleChange }) => (
                        <Form>
                            <Row>
                                <Field isFullWidth={true}>
                                    <Select
                                        name="test"
                                        label={t("Test")}
                                        required={true}
                                        options={progressTests}
                                        onChange={handleChange}
                                        selectedValue={values.test}
                                        error={formErrors?.test}
                                        searchInDropdown={false}
                                    />
                                </Field>
                            </Row>
                        </Form>
                    )}
                </Formik>
            </Main>
        </DefaultLayout>
    );
};

export default AddProgressTest;
